import BaseApi from './baseApi';
import IListPhonePrefix from '../models/IListPhonePrefix';
import IAuthentication from '../models/IAuthentication';
export default class ListPhonePrefixesApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListPhonePrefixes() : Promise<IListPhonePrefix[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listPhonePrefix: IListPhonePrefix[] = [];
            listPhonePrefix = response.data as IListPhonePrefix[];
            return listPhonePrefix;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListPhonePrefix(listPhonePrefix: IListPhonePrefix) : Promise<string> {
        const json = this.getJsonSave(listPhonePrefix);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListPhonePrefix(listPhonePrefix: IListPhonePrefix) : Promise<boolean> {
        const json = this.getJsonUpdate(listPhonePrefix);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    async DeleteListPhonePrefix(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_PHONE_PREFIX_IN_USE",
            "parameters": [{
                "Item1": "PhonePrefixId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListPhonePrefixes",
                "Item2": "id"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "country"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "prefix"
            }],
            "tables": [{
                "Item1": "ListPhonePrefixes"
            }],
            "conditions": [{
                "Item1": "ListPhonePrefixes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListPhonePrefixes",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListPhonePrefixes.country"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListPhonePrefixes",
            "conditions": [{
                "Item1": "ListPhonePrefixes",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listPhonePrefix: IListPhonePrefix) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "country",
                "Item2": listPhonePrefix.country
            }, {
                "Item1": "prefix",
                "Item2": listPhonePrefix.prefix
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListPhonePrefixes"
        };
        return json;
    }

    private getJsonUpdate(listPhonePrefix: IListPhonePrefix) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "country",
                "Item2": listPhonePrefix.country
            }, {
                "Item1": "prefix",
                "Item2": listPhonePrefix.prefix
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListPhonePrefixes",
            "keyvalue": listPhonePrefix.id
        };
        return json;
    }
}
